import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { StyleRoot } from 'radium';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import { Provider } from "react-redux"
import store from './store';

ReactDOM.render(
	<StyleRoot>	
		<BrowserRouter>
			<Provider store={store}>
				<App />
			</Provider>
		</BrowserRouter>
	</StyleRoot>
	, document.getElementById('main'));



// WEBPACK FOOTER //
// ./src/index.js